import "./BreadcrumbItem.scss";
import { ColorTheme } from "/Models/Models/ColorTheme";
import { BreadcrumbProps } from "/Models/Generated/BreadcrumbProps";
import { createSpreadableBem } from "/Helpers/createBem";

interface Props extends BreadcrumbProps {
  isMobile?: boolean;
  theme?: "default" | "insight";
  onEllipsisClick?: () => void;
  isEllipsis?: boolean;
  noArrow?: boolean;
}

const ArrowBreadcrumbIcon = (color: ColorTheme, className: string) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="12"
    viewBox="0 0 6 12"
    fill="none"
    className={className}
  >
    <path
      d="M0.146627 5.64626L5.14607 0.646819C5.19252 0.600368 5.24766 0.563523 5.30835 0.538384C5.36904 0.513246 5.43409 0.500307 5.49978 0.500307C5.56547 0.500307 5.63052 0.513247 5.69121 0.538384C5.7519 0.563523 5.80704 0.600368 5.85349 0.646819C5.89994 0.693269 5.93679 0.748413 5.96192 0.809103C5.98706 0.869792 6 0.934839 6 1.00053C6 1.06622 5.98706 1.13127 5.96192 1.19196C5.93679 1.25265 5.89994 1.30779 5.85349 1.35424L1.20713 5.99997L5.85349 10.6457C5.9473 10.7395 6 10.8667 6 10.9994C6 11.1321 5.9473 11.2593 5.85349 11.3531C5.75968 11.4469 5.63245 11.4996 5.49978 11.4996C5.36711 11.4996 5.23988 11.4469 5.14607 11.3531L0.146627 6.35368C0.100144 6.30725 0.0632682 6.25211 0.0381088 6.19142C0.0129495 6.13073 4.75052e-07 6.06567 4.80796e-07 5.99997C4.8654e-07 5.93427 0.0129495 5.86921 0.0381088 5.80852C0.0632682 5.74783 0.100144 5.69269 0.146627 5.64626Z"
      fill={color}
    />
  </svg>
);

const BreadcrumbItem = ({
  text,
  link,
  isMobile,
  isEllipsis,
  theme = "default",
  noArrow = false,
  onEllipsisClick,
}: Props) => {
  const bem = createSpreadableBem("breadcrumb-item-norad");
  return (
    <>
      {!!link && isMobile && (
        <a
          href={link.href}
          {...(link.target ? { target: link.target } : {})}
          {...(link.isExternal ? { rel: "noopener noreferrer" } : {})}
          {...bem("__link-mobile", {
            "--insight": theme === "insight",
          })}
        >
          {!noArrow &&
            ArrowBreadcrumbIcon(
              theme === "insight"
                ? ColorTheme.insightPurple1
                : ColorTheme.iconStrong,
              "breadcrumb-item-norad__icon"
            )}
          <span>{link.text}</span>
        </a>
      )}
      {!!link && !isMobile && !isEllipsis && (
        <a
          href={link.href}
          {...(link.target ? { target: link.target } : {})}
          {...(link.isExternal ? { rel: "noopener noreferrer" } : {})}
          {...bem("__link-desktop", {
            "--insight": theme === "insight",
          })}
        >
          <span>{link.text}</span>
          {!noArrow &&
            ArrowBreadcrumbIcon(
              theme === "insight"
                ? ColorTheme.insightPurple1
                : ColorTheme.iconStrong,
              "breadcrumb-item-norad__icon"
            )}
        </a>
      )}
      {text && (!link || !link.href || !isEllipsis) && (
        <p
          {...bem("__text", {
            "--insight": theme === "insight",
          })}
        >
          <span>{text}</span>
        </p>
      )}
      {isEllipsis && (
        <button
          type="button"
          aria-label="Vis skjulte brødsmuler"
          {...bem("__ellipsis-button", { "--insight": theme === "insight" })}
          onClick={onEllipsisClick}
        >
          <span aria-hidden="true">&hellip;</span>
          {ArrowBreadcrumbIcon(
            theme === "insight"
              ? ColorTheme.insightPurple1
              : ColorTheme.iconStrong,
            "breadcrumb-item-norad__ellipsis-button__icon"
          )}
        </button>
      )}
    </>
  );
};

export default BreadcrumbItem;
